export default __webpack_public_path__ + "static/cta-busy-1-83288bc895dcb4d475820345e12438c9.jpg";